import clsx from 'clsx';
import Style from './recordRow.module.scss';
import { FC, PropsWithChildren, useState } from 'react';
import { AppButton } from 'uikit/buttons';

import { ReactComponent as Chevron } from 'src/assets/img/common/chevron.svg';
import { Collapse } from 'uikit/collapse/Collapse';

type RecordsGroup = {
  title: string;
  isExpandDefault: boolean;
  rightElement?: JSX.Element;
};

export const RecordsGroup: FC<PropsWithChildren<RecordsGroup>> = ({
  isExpandDefault,
  title,
  children,
  rightElement,
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(isExpandDefault);

  return (
    <div className={Style.container}>
      <div className={Style.titleContainer}>
        <p>{title}</p>
        <AppButton
          colorSchema={'primary'}
          variant={'icon-link'}
          iconClassName={clsx({ [Style.chevronExpanded]: !isExpanded })}
          Icon={Chevron}
          onClick={() => setIsExpanded((state) => !state)}
        />
        <div className={Style.rightElement}>{rightElement}</div>
      </div>
      <Collapse in={isExpanded} unmountOnExit>
        {children}
      </Collapse>
    </div>
  );
};
